import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import TMGFHomepage from './components/Home/TMGFHomepage';
import HelpPage from "./components/Help";
import Login from './components/Authentication/Volunteer/Login';
import Registration from './components/Authentication/Volunteer/Registration';
import VolunteerDashboard from './components/Features/VolunteerDashboard/VolunteerDashboard';
import AdminDashboard from './components/Features/AdminDashboard/AdminDashboard';

import AdminLogin from './components/Authentication/Admin/AdminLogin';
import AccountConfirmationPage from './components/Features/AdminDashboard/AccountConfirmation';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

// Import Intern Authentication components
// import InternLogin from './components/Authentication/Intern/InternLogin';
// import InternRegister from './components/Authentication/Intern/InternRegister';

// // Import Intern Dashboard components
// import InternDashboard from './components/Features/InternDashboard/InternDashboard';
// import InternProfile from './components/Features/InternDashboard/Profile/InternProfile';
// import InternHome from './components/Features/InternDashboard/Home/InternHome';
// import InternDailyLogs from './components/Features/InternDashboard/DailyLogs/InternDailyLogs';
// import InternKanban from './components/Features/InternDashboard/KanbanBoard/InternKanban';
// import InternFiles from './components/Features/InternDashboard/Files/InternFiles';

// Import Intern Management components (for admin)
// import InternOnboarding from './components/Features/InternManagement/InternOnboarding/InternOnboarding';
// import TaskBoard from './components/Features/InternManagement/TaskBoard/TaskBoard';
// import DailyLogs from './components/Features/InternManagement/DailyLogs/DailyLogs';
// import FeedbackManagement from './components/Features/InternManagement/FeedbackManagement/FeedbackManagement';
// import FileManagement from './components/Features/InternManagement/FileManagement/FileManagement';

// Import your actual components
import OrganizerView from './components/Features/AdminDashboard/Event/OrganizerView';
import AllVolunteers from './components/Features/AdminDashboard/VolunteerList/AllVolunteers';
import VisitorDashboard from './components/Features/AdminDashboard/VisitorManagement/VisitorDashboard';
import Help from './components/Features/AdminDashboard/VolunteerInitiatives/VolunteerInitiatives';
import VolunteerView from './components/Features/VolunteerDashboard/Event/VolunteerView';
import Profile from './components/Features/VolunteerDashboard/Profile/Profile';
import HelpSection from './components/Features/VolunteerDashboard/VolunteerInitiatives/VolunteerInitiatives';
import HelpMe from './components/Features/VolunteerDashboard/HelpMe/HelpMe';
import Home from './components/Features/VolunteerDashboard/Home/Home';
import VisitorRegistration from './components/Authentication/Visitor/VisitorRegistration';
import GroupDetails from './components/Authentication/Visitor/GroupDetails';

// Import 404 Page
import NotFound from './components/NotFound/NotFound';

// Import Chatbot Identifier
import ChatbotIdentifier from './components/Chatbot/ChatbotIdentifier';

function App() {
  return (
    <Router>
      <ChatbotIdentifier />
      <Routes>

        {/* Home */}
        <Route path="/" element={<TMGFHomepage />} />

        {/* Help Page */}
        <Route path="/help" element={<HelpPage />} />

        {/* Volunteer Authentication */}
        <Route path="/login" element={<Login />} />
        <Route path="/Registration" element={<Registration />} />

        {/* Admin Authentication Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Visitor Registration */}
        <Route path="/visitor/register" element={<VisitorRegistration />} />
        <Route path="/visitor/group-details" element={<GroupDetails />} />

        {/* Admin Dashboard */}
        <Route path="/admin-dashboard/:uid" element={
          <ProtectedRoute requiredRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="visitors" replace />} />
          <Route path="organizer-view" element={<OrganizerView />} />
          <Route path="allvolunteers" element={<AllVolunteers />} />
          <Route path="visitors" element={<VisitorDashboard />} />
          <Route path="help" element={<Help />} />
          <Route path="account-confirmation" element={<AccountConfirmationPage />} />
        </Route>

        {/* Volunteer Dashboard */}
        <Route path="/dashboard/:uid" element={
          <ProtectedRoute requiredRole="volunteer">
            <VolunteerDashboard />
          </ProtectedRoute>
        }>
          <Route path="profile" element={<Profile />} />
          <Route path="home" element={<Home />} />
          <Route path="volunteer-view" element={<VolunteerView />} />
          <Route path="help" element={<HelpSection />} />
          <Route path="help-me" element={<HelpMe />} />
          <Route index element={<Navigate to="home" replace />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
}
export default App;
